import { spaceUsedType } from '../constants/action-types'

const initialState = {
  data: [],
  error: ''
}
export const spaceUsedReducer = (state = initialState, action) => {
  switch (action.type) {
    case spaceUsedType.SPACEUSED_REQUEST:
      return {
        ...state
      }
    case spaceUsedType.SPACEUSED_SUCCESS:
      return {
        ...state,
        data: action.payload.data.data
      }
    case spaceUsedType.SPACEUSED_FAILURE:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}
